var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "725.916 277.806 126.084 126.625",
    width: "126.084pt",
    height: "126.625pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_6WzQTH1Jmb6TDhbEWPgWa266XTfY8aGn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 725.916,
    y: 277.806,
    width: 126.084,
    height: 126.625
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_6WzQTH1Jmb6TDhbEWPgWa266XTfY8aGn)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 825.434 383.9 C 827.586 388.488 830.84 393.774 835.099 400.785 C 836.235 402.655 835.147 403.671 833.119 404.215 C 828.502 405.452 815.815 401.083 811.288 398.469 C 809.608 397.5 807.398 396.213 804.986 394.602 L 790.834 402.01 C 785.419 404.844 777.475 403.675 773.105 399.401 L 730.317 357.541 C 725.948 353.266 724.605 345.35 727.32 339.874 L 753.907 286.247 C 756.622 280.771 763.736 277.048 769.784 277.937 L 829.005 286.652 C 835.052 287.542 840.792 293.157 841.814 299.183 L 851.825 358.197 C 852.848 364.223 849.281 371.417 843.865 374.252 L 825.434 383.9 Z  M 824.504 358.081 L 799.951 356.118 L 787.505 377.454 C 785.663 380.613 783.47 380.292 782.612 376.736 L 776.826 352.751 L 752.826 347.524 C 749.252 346.746 748.884 344.564 752.004 342.655 L 773.009 329.803 L 770.524 305.306 C 770.155 301.667 772.115 300.64 774.898 303.013 L 793.59 318.953 L 816.175 309.035 C 819.524 307.564 821.107 309.114 819.708 312.493 L 810.261 335.315 L 826.69 353.671 C 829.129 356.396 828.15 358.372 824.504 358.081 Z ",
    fillRule: "evenodd",
    fill: "rgb(1,140,73)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d9b026c7.svg";
export { ForwardRef as ReactComponent };